import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GLOBAL_ROUTING_FEATURE_KEY, GlobalRoutingState } from './routing-state.reducer';

export const selectGlobalRoutingState = createFeatureSelector<GlobalRoutingState>(GLOBAL_ROUTING_FEATURE_KEY);

export const selectCurrentRouteUrl = createSelector(selectGlobalRoutingState, ({ currentRouteUrl }) => currentRouteUrl);
